import './App.css';

import Whiteboard from './components/Whiteboard'

function App() {
  return (
    <div className="App">
      <Whiteboard />
    </div>
  );
}

export default App;
